"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base validation state class
 */
var State = function () {

  /**
   * @type {string}
   */

  /**
   * @type {Message|string}
   */
  function State(_ref) {
    var attribute = _ref.attribute,
        message = _ref.message;

    _classCallCheck(this, State);

    this.attribute = attribute;
    this.message = message;
  }

  _createClass(State, [{
    key: "getStatus",
    value: function getStatus() {
      return State.STATUS;
    }
  }]);

  return State;
}();

State.STATUS = undefined;
exports.default = State;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/states/validation/State.js
// module id = 44
// module chunks = 0